<template>
    <div class="map-list">
        <!-- 头部搜索框 -->
        <div class="map-search">
            <div class="map-search-title">
                <template v-for="(item, index) in path" :key="index">
                    <div class="map-folder" :class="index == path.length - 1 ? 'map-folder-active' : ''"
                        @click="toFolder(index)">
                        {{ item.name }}
                    </div>
                    <span v-if="index < path.length - 1"
                        class="map-folder-separator icon-glyphicon-chevron-right"></span>
                </template>
            </div>
            <div class="map-search-sort">
                <div class="sort-title" @click="sortListShow = !sortListShow">
                    <span class="sort-title-text">{{ sortInfo.name }}</span>
                    <span class="sort-title-icon"></span>
                </div>
                <ul class="map-drop-down-list" v-show="sortListShow">
                    <li class="map-drop-down-list-item" @click="sortInfo.name = '创建时间'">
                        创建时间
                    </li>
                    <li class="map-drop-down-list-item" @click="sortInfo.name = '更新时间'">
                        更新时间
                    </li>
                    <li class="map-drop-down-list-item map-drop-down-list-item-active" @click="sortInfo.name = '名称'">
                        名称
                    </li>
                    <li class="map-drop-down-list-divider"></li>
                    <li class="map-drop-down-list-item map-drop-down-list-item-active">
                        升序
                    </li>
                    <li class="map-drop-down-list-item">
                        降序
                    </li>

                </ul>
            </div>
            <div class="map-search-recycle">
                <img width="15"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA0CAYAAAD46nqNAAAAAXNSR0IArs4c6QAACANJREFUaEPNWXtQlNcV/51vl7cgoqADkYAGhyCGRg2v+MRdtZoEDUunKcbdZqaZ6WtsZzrttPm7maad6fQxTf9qAoyddGSh0ZkYcReIhodRYlCR+IhGDCgC8pD3Y7/TuRcWWPZbdllmJ72zj9l7z/md35xzzzn3fkvwYZw+fTukc6j19wB+CnCoDyoeRYiImfl0SHDYm6/lb3vgDYu8CTQ2NgZdv9dXycy7vckuap3obnCILusHL+/uXkjPK8Fiq+3HYLy7KOM+ChPRX80mwy+WRLDEav8XM78hQBTCPwH9e4p+csxHDi5iPKFEqqS+xYwDcoHorsVkWL80gmW2kwy8IkCCQ/Wx3kLijXhpRVWe6lCrJD9Qr7nQEOM3wQ9O1saPj49eYfAqAaIPoo1HDhlavJFYaL20wv591cEfTMuo+ojIFUcOZD/xpCP3oEiElvt9BezALhASAYQycxSB0hgc5lQmwpdgnACUEb9IkhrNTD8EePUczEZisqmEiak57gB05y2mvOvSyyfq68NGHgzVMCPLL6MBUJKlCPi7xWQ4RqXl9l+rKr8TADtLhiQiCxVb7efBvH3JaIEAIFRRcZm9Y+6eCIQdfzGJ0EnFVtsoGCH+ggRST5Sh/2uCIAyLEJ8F2BhIT/iLTUAtiRp4o/VJpspY7i9QIPQUQn/q01EXvR4WAmF8MZiS4Ikz9TGTg2NxE3AEL0Y5ULJB0I1zqP5R0UvbZZK8SYx3GdAFyqA/uEQ0CcZhKimzVzD4sD8gAddR6Hcii48DXBRwY/4YIPyESqy2PzHjV/7oB1pHR3SYSqz2Y8z8l0Ab8wef9EoWlZZVv6rCUe4PQKB1QoKCE6nUWp2lsuPCYo1FRYZjR2Y6VkRHQqGpcsrM8n3r63bcutuOuJXR6O7tx+PegcXCQ5wJNyZFh1DJKVsij6F1MQiKQsg35kCQnD9u3W3D4PAovrNxvSSuqiqq6q7gwaPHizEhZLsshcY4OtHcHDxyo2OUmX3uKs+lJuP5dPfL2PDIGJpa7iB3S5oLGTH/4dkGTExM+kySiK6aTYYMSaqkzN7lvBh5Q1gWHor8fTnQ69zr+qcXm5EYH4unn5q5cszAff1NB/r6h9D+qNunkBOh0mwy7pcEi8tsVwFs8kZOrOflZmBtfKybaHdPPz6qviT33Xd3b9WE6nrcj9M1l3wxAwLeNxca35jyoNVWyYy93jSJCJkZG7BhXQIURXERF4YFATF25zyHxIQ4N7iPP2lEZ3efNzNynRR621xgeGuaoL2Ymc0+aQIyObZuSpnx5L22Rzh34dqM+sroSLxkcL0k3m/vRE2DCJRvQyH62VGT4R+SYGmZ/W0V/FstVRHO+DjXy39bRzfaOx5jTewKbE5/Buc/uyYz1znE3PKoCJnFIuNF6fms6SYGBkewPDICoSFBeOTFkwp0BUcL8yqmPFhu+zmr+JsWQRHWXdmbXEI2Nj6Bio/rML6IrBRERfanpyZBZnVlgyxBngbpKNf8qqFhmqDdxCqXaRIE8MrebERHLXNZbr7Zis+v3fYpXsLT2ZtTpfec43LzV7h2455H/SBFSSoq2NMqCR4vr35xUnXUakmnJMe71TUh53Co+O+ZegyNzIZWSz8xIRa7czLcliYmHfjwTD2GR7UflMVFJIUeOJAyJgn+22pbN8G4o2Wg8OB2hIe530q/edCFnr4BNLXcXdCLItvz92YjaplW12lHw+UvtfR7LIXGlTKbxYd4PjPcPjSsJfla/i4EB+ldlvoHhnDKdgGqyj6FOH51DIzbN7vJDgwOo+JMvds8EZrNJqOsyzPtrdhq7wVz9Hzp5LVrsO2FNJe6V3nuc3R09fpEzim0I2sTkte6dpi2h92oqmvSwCGbpdAg6/IMwRKrrYUZz86XFlkcs3yZbF8R4aHo6OzB7Xten33jmaR4fDVHLiw0GIf25bpE4+z5y3jY2aPhQSoxmwwWV4Jl9ioG52kRFHsIDFnrRsfGweLH1EucseT3paZbmHQ4pLogc3h/Lu7ce4iRsXE5J0qL2CovZGyQv+8/6EJN/RXNKBDhD2aTUdbl2RAvcDdJemo1dmYv3Kr/c+ocRH0U48WtadKD80fdpRZkpCXLpBOnG1G4tYZCdOyoySDr8twQL3g3OZiXiVUxUR73nZOgaHMH92SKA6ebrOjDYu/qdAoar3quoaRQobnAYJ2XJLZfgvFnTwwWOqUIHSfB3C3PIiU5QRNG1L6q2i/Q0zeIiUnPZ0O9ott2pCCvzoXgvIfbmga2Z6ZjXeIazTUnwbhV0di/c4umB7t7nuCj6oseo+BcCCKsLzIZZYGdiUNpRfVO1eH4ZCFtvU5B5vOpEHUtNCQYujlHrrl7cL4XRc/t7R9EXWOL/PY2whMiwr+Xmys36OwerLBvYAff9KY8dz1Ir4N++j04ODKV1QBCgoNwaF8Ovrh+B61tnTPJ4xM2UZ/FZFjhlJ0hePJkbWTv+IjH/yt8Ap8jJIpy28PHC+41bUxqsRQaNroRFBMlZfYBBrseWxbLbKnyhCqLyWjQJFhstd0CI2WpNpaiT0THzSbD69oetNrPMfOOpRhYui790VJo+I0HD9rfB7Psgd/WmNtFXLJY/Cgtr3pdVdXSb4ucJKRQnrnAUKPpQfF0obS86h1mLiJgNYgU8f89iXOB/CsfLK9AJM4LJOeZxIumLxes8pweRzxbxiBUxdmCZueIp/rhNMYwE06aC/b8SDyXcRL8H3AIOCWgA3YmAAAAAElFTkSuQmCC">
                <span>回收站</span>
            </div>

            <div class="search-layout">
                <img class="map-search-recycle-icon" width="17" height="16"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAAAXNSR0IArs4c6QAABFlJREFUWEfNl2toHFUUx/9nZpOASgxiYlZB8RX1k61URar1keCHarFaDKRWsD7mTrIRUoki+GEdPxQNUcR1d+ZeJRXxgdGAj1itGBotqLT4wKpEKfhFcEXrKzba7maOHJwtmzTZmXYX7P22e8/539+999xzzhCOk0HHCQcSgzAzZTKZVeVyeS2AqwGcAaCDiA4wcxHAN5ZlbSeiHb7v/3a0G0wE4rrujcz8CDOvjFuAiP4G8HQqlXosn8/vj7OvzNcEGRoaapubm3sBwA3VgkT0J4DvmfknACcASAM4B1hwwr8D2GSMeTsJzLIgmUymq1Qqich5IkREIYCXmHksnU7v8jyvXL3A4ODg6aVSaT0zPwDgrIoPMz9kjHk0DmZJEMdxTgWwG8DZkeBXzLzRGLM3TjCbzTYXi8UHAWSZ2YrsB4wxfi3fI0Cy2axVLBanmfmqCOJd27ZvLRQKf8VBVM8rpdYx82sAmgHM27bd7fv+B8tpHAHiuu7tYRg+Hzl80draeuXo6OiBo4Go2Lque0cYhtsqp9rd3b2it7d3fimtBSCO4zQB2AfgTNlFU1PTxfl8/utjgaj4KKUmmPkW+W1Z1uYgCJ5LAnI9gB2R4bPGmHvqgRBfx3HOJaLvJF6IaFprfW0SkAKAfjFMpVKrC4XCR/WCiL9SaiczXyMvr7m5uTOXy/28WHfB1Sil9jDzKiLaHwRBOxFxg0DuY+bHo1jp0VpP1QRxHEdS9WlEtFtrfXkjIERDMnMYhm9FceIEQfBMHMhBeW5ENKm1XtcokIGBgUvL5bLkJRlbjDFPxl3Nj8zcCWCPMeayRoEsOpG7giAYizuRzwGsAPBrOp1u9zxP0nrdQyl1OEZs217r+/47cSA5AINiZNv2Gt/3d9VN8d8TnpbWQV4NM59ijPkjDkSq7GQU3du01nfWC6KUOh/ATJRHPtFaX5Ekj0hm/VaKndBblrXS9/0v64FRSr3OzDdFm9uotX45FiRKPpul1EfGe9va2laPjIzMHguM67oqDMMg8t3X09NzYaJaIw7j4+P21NTUe8x8XSTwfktLy4ZcLifNUOLhum4vM7/IzCkikt5ljdb64+UEavUjn0bFT3xnANxmjPksjmR4ePjE2dlZ6UXur9gSkdFaq1q+y3Zo/f39F8zPz78JoCsSYCKasCxrrKOjY6fnef9UC0f2NwMYkuxcPUdEB5l5Q622sWbP6jjOyQCkbK9ftBuB+IGIfmHmSs/avshG5rczsxP9f4iIerXWbyQK1qWMlFLdALYyc2y2lYIJwNi2vVW6Otd1t4Rh+ESkW7Isqy8IgomaeSTu/qWhLpfLGwBcwsxdRHQSgBIA6eYlK3/Y2dk56XneoWotpdS9zPxU9IQlcDdprV9ZcH1xizdqXinlMrP0OxIO0i72GWNePRzQjVooiY7jOHfLtUUwM8aYi/4XEFlUKdXHzA8TkdZaV2In+bdvkh3XY5Po27eeBZL6/gv+qcUwfM5HUQAAAABJRU5ErkJggg==">
                <input type="text" id="searchInput" placeholder="请输入关键字进行搜索" />
                <span class="reset-search-btn" style=""></span>
            </div>
        </div>
        <!-- 地图列表 -->
        <div class="maps-search-list">
            <CreateMap :folder="nowFolder" @map-refresh="refreshList" />


            <template v-for="(item, index) in currentPageItems" :key="index">
                <FolderCard v-if="item.type === 'folder' && item.delFlag == '0'" :item="item" @map-refresh="refreshList"
                    @click="inFolder(item)" />
                <MapCard v-if="item.type === 'atlas' && item.delFlag == '0'" :item="item" @map-refresh="refreshList" />
            </template>


            <!-- 补充占位符 -->
            <template v-for="index in placeholderCount" :key="'placeholder-' + index">
                <div class="map-placeholder"></div>
            </template>
        </div>
        <!-- 分页 -->
        <div class="map-page">
            <ul class="map-page-pagination">
                <li>
                    上一页
                </li>

                <li v-for="index in Math.ceil((combinedList.length) / pageSize)" :key="index" class="map-page-active"
                    @click="changePage(index)">
                    {{ index }}
                </li>
                <li>
                    下一页
                </li>
            </ul>

        </div>
    </div>
</template>

<script>

import CreateMap from '@/components/common/CreateMap.vue';
import FolderCard from '@/components/common/FolderCard.vue';
import MapCard from '@/components/common/MapCard.vue';

import { getAtlasList, getFolderList } from '@/api/Common';

import { useMapStore } from '@/stores/mapStore';

export default {
    name: 'MapList',
    components: {
        CreateMap,
        FolderCard,
        MapCard
    },
    data() {
        return {
            sortListShow: false,
            sortInfo: {
                name: '名称',
                type: 'asc',
            },
            path: [{
                name: '工作台',
                id: null,
            }],
            sortData: [],
            atlasList: [],
            folderList: [],
            mapStore: null,
            userInfo: {},
            pageNum: 1,
            pageSize: 11 // 每页显示的数量

        }
    },
    computed: {
        nowFolder() {
            return this.path[this.path.length - 1];
        },
        // 合并 folderList 和 atlasList
        combinedList() {
            return [
                ...this.folderList.filter(item => item.delFlag === '0').map(item => ({ ...item, type: 'folder' })),
                ...this.atlasList.filter(item => item.delFlag === '0').map(item => ({ ...item, type: 'atlas' }))
            ];
        },
        // 当前页的项目
        currentPageItems() {
            const start = (this.pageNum - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.combinedList.slice(start, end);
        },
        // 需要补充的占位符数量
        placeholderCount() {
            const remainder = (this.currentPageItems.length + 1) % 4;
            return remainder === 0 ? 0 : 4 - remainder;
        }
    },
    mounted() {
        this.mapStore = useMapStore();
        this.userInfo = this.mapStore.getUserInfo();
        this.getAtlasList({ userId: this.userInfo.userId });
        this.getFolderList({ userId: this.userInfo.userId });
    },
    methods: {
        inFolder(item) {
            this.path.push({
                name: item.fileName,
                id: item.id,
            });
            this.changeFolder();
        },
        toFolder(index) {
            this.path = this.path.slice(0, index + 1);
            this.changeFolder();
        },
        changeFolder() {
            let folder = this.path[this.path.length - 1];
            this.folderList = this.mapStore.folderList.filter(item => item.pid === folder.id);
            this.atlasList = this.mapStore.atlasList.filter(item => item.folderId === folder.id);
        },
        refreshList() {
            this.getAtlasList({ userId: this.userInfo.userId });
            this.getFolderList({ userId: this.userInfo.userId });
        },
        changePage(page) {
            this.pageNum = page;
        },
        getFolderList(params) {
            let that = this;
            getFolderList(params).then(res => {
                if (res.code == 200) {
                    // 获取当前节点的 id
                    const currentFolderId = that.path[that.path.length - 1].id;
                    that.mapStore.folderList = res.rows;
                    // 过滤出父节点是当前节点的对象
                    that.folderList = res.rows.filter(item => item.pid === currentFolderId);
                }
            })
        },
        getAtlasList(params) {
            let that = this;
            getAtlasList(params).then(res => {
                if (res.code == 200) {
                    // 获取当前节点的 id
                    const currentFolderId = that.path[that.path.length - 1].id;
                    // that.atlasList = res.rows;
                    that.mapStore.atlasList = res.rows;
                    that.atlasList = res.rows.filter(item => item.folderId === currentFolderId);
                }
            })
        }

    }
}

</script>

<style scoped>
@import url('@/assets/css/mapList.css');

.map-page-pagination {
    float: right;
    margin-right: 150px;
    padding-left: 0;
    border-radius: 4px;
    padding: 0;
    list-style: none outside none;
}

.map-page-pagination li {
    position: relative;
    display: inline;
    list-style: none;
    cursor: pointer;
    border: none;
    background-color: transparent;
    line-height: 1.42857143;
    float: left;
    color: #4a4a4a;
    font-size: 16px;
    padding: 6px 12px;
    margin-left: -1px;
}

.map-folder {
    -webkit-user-select: none;
    /*webkit浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
}

.map-page-active {
    color: #2d8cf0 !important;
}

.map-page-pagination li:hover {
    color: #428bca;
    background-color: #eee;
}
</style>